import { render, staticRenderFns } from "./my-product.vue?vue&type=template&id=1fdac3f8&scoped=true&"
import script from "./my-product.vue?vue&type=script&lang=js&"
export * from "./my-product.vue?vue&type=script&lang=js&"
import style0 from "./my-product.vue?vue&type=style&index=0&id=1fdac3f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdac3f8",
  null
  
)

export default component.exports